import React, { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode } from "primereact/api";
import { Button } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import STcontext from "../context/STcontext";
import { AuthContext } from "../context/AuthContext";

const AppareilByType = () => {
  const { type } = useParams(); // 'GPS' ou 'SIM'
  const { user } = useContext(AuthContext);
  const { getGerantAppareil, gerantAppareil } = useContext(STcontext);
  const navigate = useNavigate();
  
  const [allDevices, setAllDevices] = useState([]);
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  useEffect(() => {
    getGerantAppareil();
  }, []);

  useEffect(() => {
    if (gerantAppareil) {
      const devices = type === 'GPS' ? gerantAppareil.AllGPS : gerantAppareil.AllSIM;
      setAllDevices(devices || []);
      setSelectedDevices(devices || []);
    }
  }, [gerantAppareil, type]);

  // Fonction de filtrage par status
  const handleStatusFilterChange = (e) => {
    const value = e.target.value;
    setStatusFilter(value);
    
    let etat = "";
    let garantie = "";
    
    switch (value) {
      case "new":
        etat = 0;
        garantie = 0;
        break;
      case "installed":
        etat = 1;
        break;
      case "uninstalled":
        etat = 2;
        break;
      case "good_opportunity":
        etat = 0;
        garantie = 1;
        break;
      case "damaged":
        etat = 3;
        break;
      case "deleted":
        etat = 4;
        break;
      default:
        etat = "";
        garantie = "";
    }

    const filteredDevices = allDevices.filter(
      (device) =>
        (etat === "" || device.etat == etat) &&
        (garantie === "" || device.garantie == garantie)
    );
    
    setSelectedDevices(filteredDevices);
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters["global"].value = value;
    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const renderHeader = () => {
    return (
      <div className="flex justify-content-end">
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            placeholder="Recherche par mot clé"
          />
        </span>
      </div>
    );
  };

  const formatDate = (value) => {
    return new Date(value).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  const formatDateBody = (rowDate) => {
    return formatDate(rowDate.created_at);
  };

  const getStatus = (redStatus) => {
    const status = redStatus.etat;
    const garantie = redStatus.garantie;
    switch (status) {
      case 0:
        switch (garantie) {
          case 0:
            return "Nouveau";
          case 1:
            return "Bon Occasion";
          default:
            return "Non installé";
        }
      case 1:
        return "Installé";
      case 2:
        return "Désinstallé";
      case 3:
        return "Endommagé";
      case 4:
        return "Supprimé";
      default:
        return "Inconnu";
    }
  };

  const getSeverity = (redStatus) => {
    const status = redStatus.etat;
    const garantie = redStatus.garantie;
    switch (status) {
      case 0:
        switch (garantie) {
          case 0:
            return "success";
          case 1:
            return "warning";
          default:
            return "secondary";
        }
      case 1:
        return "info";
      case 2:
        return "renewal";
      case 3:
      case 4:
        return "danger";
      default:
        return "primary";
    }
  };

  const statusBodyTemplate = (rowData) => {
    return <Tag value={getStatus(rowData)} severity={getSeverity(rowData)} />;
  };

  const logDeviceBody = (rowData) => {
    
    return (
      <Button
        onClick={() => navigate(`/SupportTechnique/appareils/${type}/log/${rowData.serial_number}`, {
          state: { idDevice: rowData.id }
        })}
        variant="info"
        size="sm"
      >
        Voir logs
      </Button>
    );
  };

  // Statistiques des appareils par status
  const getStatusCount = (statusValue, garantieValue = null) => {
    return allDevices.filter(device => {
      if (statusValue === 0 && garantieValue !== null) {
        return device.etat === statusValue && device.garantie === garantieValue;
      }
      return device.etat === statusValue;
    }).length;
  };

  const header = renderHeader();

  return (
    <div style={{
      width: "90%",
      padding: "2rem",
      marginTop: "1rem",
      marginLeft: "50px",
      borderRadius: "2rem",
    }}>
      <div style={{
        backgroundColor: "white",
        width: "100%",
        padding: "2rem",
        marginTop: "1rem",
        borderRadius: "2rem",
      }}>
        <div className="bar-table" style={{ padding: "0rem 2rem 1rem 2rem" }}>
          <div>
            <h5>
              {type} &nbsp; <span className="vl"></span> &nbsp;
              <span style={{ fontSize: "15px" }}>
                {selectedDevices?.length || 0} Appareils
              </span>
            </h5>
          </div>
        </div>

        {/* Filtre par status */}
        <Row md="2">
          <Form.Group
            className="mb-2 mx-2"
            as={Col}
            md="4"
            controlId="validationCustom01"
          >
            <Form.Label>Filtrer les appareils par:</Form.Label>
            <Form.Select
              required
              type="text"
              name="type"
              value={statusFilter}
              onChange={handleStatusFilterChange}
            >
              <option value="">Tous les appareils ({allDevices.length})</option>
              <option value="new">Nouveaux ({getStatusCount(0, 0)})</option>
              <option value="installed">Installés ({getStatusCount(1)})</option>
              <option value="uninstalled">Désinstallés ({getStatusCount(2)})</option>
              <option value="good_opportunity">Bon Occasion ({getStatusCount(0, 1)})</option>
              <option value="damaged">Endommagé ({getStatusCount(3)})</option>
              <option value="deleted">Supprimé ({getStatusCount(4)})</option>
            </Form.Select>
          </Form.Group>
        </Row>

        <DataTable
          value={selectedDevices}
          paginator
          rows={10}
          rowsPerPageOptions={[10, 25, 50, 100]}
          dataKey="id"
          filters={filters}
          globalFilterFields={["serial_number", "nameModele", "nameType"]}
          header={header}
          emptyMessage={`Aucun ${type} trouvé.`}
        >
          <Column
            header="#"
            headerStyle={{ width: "3rem" }}
            body={(data, options) => options.rowIndex + 1}
            bodyStyle={{ fontWeight: "bold" }}
          />
          <Column
            header={type === 'GPS' ? "IMEI" : "Numéro SIM"}
            field="serial_number"
            style={{ minWidth: "12rem", height: "4rem" }}
          />
          <Column
            header="Modèle"
            field="nameModele"
            style={{ minWidth: "14rem", height: "4rem" }}
          />
          <Column
            field="nameType"
            header="Type"
            style={{ minWidth: "12rem", height: "4rem" }}
          />
          <Column
            field="etat"
            header="Statut"
            sortable
            style={{ minWidth: "12rem", height: "4rem" }}
            body={statusBodyTemplate}
          />
          <Column
            field="created_at"
            sortable
            header="Date d'entrée"
            style={{ minWidth: "8rem", height: "4rem" }}
            body={formatDateBody}
          />
          <Column
            header="Actions"
            style={{ minWidth: "8rem", height: "4rem" }}
            body={logDeviceBody}
          />
        </DataTable>
      </div>
    </div>
  );
};

export default AppareilByType;